import modelMap from '@/builder/model-map'

export const injectedGridContentItemsDefinition = {
    name: 'injectedContentItems',
    type: 'list',
    subFields: [
        {
            name: 'content',
            type: 'object',
            subFields: [
                {
                    name: 'content',
                    type: 'reference',
                    model: modelMap.injectableMarketingContent,
                    required: true,
                    helperText: 'The content you want to inject into the grid.'
                },
                {
                    name: 'position',
                    type: 'number',
                    required: true,
                    helperText: 'The position to inject the content into the grid.'
                },
                {
                    name: 'largeDesktopSpan',
                    type: 'string',
                    enum: ['0', '1', '2', '3', '4'],
                    required: true,
                    helperText:
                        'The number of columns to span in the grid. If zero, the content will not be displayed at this breakpoint.'
                },
                {
                    name: 'desktopSpan',
                    type: 'string',
                    enum: ['0', '1', '2', '3'],
                    required: true,
                    helperText:
                        'The number of columns to span in the grid. If zero, the content will not be displayed at this breakpoint.'
                },
                {
                    name: 'tabletSpan',
                    type: 'string',
                    enum: ['0', '1', '2'],
                    required: true,
                    helperText:
                        'The number of columns to span in the grid. If zero, the content will not be displayed at this breakpoint.'
                },
                {
                    name: 'mobileSpan',
                    type: 'string',
                    enum: ['0', '1'],
                    required: true,
                    helperText:
                        'The number of columns to span in the grid. If zero, the content will not be displayed at this breakpoint.'
                }
            ]
        }
    ],
    required: false,
    helperText: 'Select the marketing content to inject into the grid'
}
